import { __rest, __assign } from 'tslib';
import clsx from 'clsx';
import React from 'react';
import { cssWindowBlocker, cssContainerBlocker } from './index.css.js';

var LoadingIndicator = function (_a) {
    var _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, className = _a.className, props = __rest(_a, ["isLoading", "className"]);
    return isLoading ? React.createElement("div", __assign({ className: clsx('c-loader', className) }, props)) : null;
};
var WindowBlocker = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return React.createElement("div", __assign({}, props, { className: clsx(className, cssWindowBlocker) }));
};
var WindowLoadingIndicator = function (_a) {
    var isLoading = _a.isLoading, props = __rest(_a, ["isLoading"]);
    return isLoading ? (React.createElement(WindowBlocker, __assign({}, props),
        React.createElement(LoadingIndicator, { isLoading: isLoading }))) : null;
};
var ContainerBlocker = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return React.createElement("div", __assign({}, props, { className: clsx(className, cssContainerBlocker) }));
};
var ContainerLoadingIndicator = function (_a) {
    var isLoading = _a.isLoading, props = __rest(_a, ["isLoading"]);
    return isLoading ? (React.createElement(ContainerBlocker, __assign({}, props),
        React.createElement(LoadingIndicator, { isLoading: isLoading }))) : null;
};

export { ContainerBlocker, ContainerLoadingIndicator, LoadingIndicator, WindowBlocker, WindowLoadingIndicator };
//# sourceMappingURL=index.js.map
